/**
 * Guía: Panel Financiero.
 *
 * Contenido derivado del capítulo **18** del manual: §0 (los dos dineros
 * distintos, y que las comisiones de creador son un pasivo y no un ingreso)
 * y del flujo F34, que es como se le explica a quien atiende.
 *
 * Toda la guía cuelga del primer paso. Un panel dirigido a finanzas que
 * rotule el volumen del marketplace como «ingresos» invita a leer la caja de
 * los comercios como propia, y eso lleva a decisiones equivocadas.
 */

import type { TourFlow } from '../types';

const PANEL_PATH = '/finance-dashboard';

export const c18PanelFinanciero: TourFlow = {
  id: 'admin.finance-dashboard',
  chapter: '18',
  title: 'Resumen financiero',
  summary:
    'Dos dineros que no son lo mismo: el volumen que mueve la plataforma y lo que de verdad gana.',
  href: PANEL_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Aquí se mira cómo va, no qué pasó',
      body:
        'Este panel responde «cómo vamos». Para seguir una transacción concreta está Pagos ' +
        'y Transacciones; para cuadrar lo que se le paga a un comercio, Liquidaciones.',
      route: PANEL_PATH,
    },
    {
      id: 'two-monies',
      title: 'Ventas totales no es lo que gana 121Pass',
      body:
        'Las ventas totales son todo lo que pagaron los clientes: el producto, la propina, ' +
        'los impuestos y la tarifa. La mayor parte de ese dinero es del comercio y se le ' +
        'liquida. Lo que gana la plataforma es la tarifa de servicio más la comisión que ' +
        'retiene, y va en su propia cifra.',
      target: 'admin.financeDashboard.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'creator-commissions-are-a-liability',
      title: 'Las comisiones de creador no son ingreso',
      body:
        'Las paga el comercio —se le descuentan de su liquidación— y la plataforma sólo las ' +
        'traslada al creador. Aparecen con cifra propia porque son un pasivo: dinero que ' +
        'hay que pagar, no dinero que se gana.',
    },
    {
      id: 'subscription-is-a-third-money',
      title: 'Y hay un tercer dinero',
      body:
        'El abono que pagan las compañías por usar la plataforma no es ni venta ni comisión: ' +
        'va en su propia línea, por moneda. Sumarlo al ingreso por ventas mezcla dos cosas ' +
        'que crecen por motivos distintos.',
    },
    {
      id: 'timezone',
      title: 'El periodo se resuelve en la hora del país',
      body:
        'Y el último día entra entero. Comparar con una cuenta hecha a mano en otro huso da ' +
        'distinto, y el panel tiene razón.',
    },
    {
      id: 'not-for-reconciling',
      title: 'Para cuadrar están los informes',
      body:
        'Estas cifras son para ver la marcha del negocio. Un cierre contable se hace con los ' +
        'informes financieros, que se generan para un rango explícito y dicen en qué moneda ' +
        'y en qué zona horaria están.',
    },
  ],
};
